<template>
  <div>
    <el-upload :action="uploadUrl" multiple :list-type="listType" :drag="typeDrag && !disabled" :on-success="successCb" :on-preview="preview" :on-remove="removeCb" :on-progress="uploadProgress" :on-error="uploadError" :before-upload="beforeUpload" :file-list="fileList">
      <div v-if="(typeFileList || typeImageList) && !disabled">
        <el-button size="small" type="primary">点击上传</el-button>
      </div>
      <div v-if="typePhotoWall && !disabled">
        <i class="el-icon-plus"></i>
      </div>
      <div v-if="typeDrag && !disabled">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </div>
      <div class="el-upload__tip" slot="tip" v-if="!disabled">只能上传{{ getFileType(config.file_type) }}文件，且不超过{{ config.file_max }}{{ getFileUnit(config.file_unit) }}</div>
    </el-upload>
  </div>
</template>

<script>
  /**
   * @param Number value 绑定值（时间戳）
   * @param String title 控件标题
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Object config 配置值
   * @param String uploadUrl 上传链接
   */
  import _verify from '../../../../assets/js/verify'
  import modelConfig from '../../../../config/modelConfig'
  export default {
    props: ['value', 'title', 'name', 'disabled', 'config', 'uploadUrl'],
    data() {
      return {
        COMPONENT_NAME: 'honrayUpload',
        host: '',
        fileList: [],
        successCb: null,
        removeCb: null,
        berforeUpload: null,
        listType: '',
        drag: false,
        fileType: [
          { id: 10, name: '图片' },
          { id: 20, name: '压缩文件' },
          { id: 30, name: 'word文档' },
          { id: 40, name: 'excel表格' },
          { id: 50, name: 'ppt幻灯片' },
          { id: 60, name: 'PDF' }
        ]
      }
    },
    mixins: [modelConfig],
    created() {
      this.host = HOST
      this.initData()
      this.init()
    },
    mounted() {
      let labels = document.getElementsByClassName('el-upload-list__item-status-label')
      if (this.disabled) {
        for (let i = 0; i < labels.length; i++) {
          labels[i].style.display = 'none'
        }
      }
    },
    methods: {
      initData() {
        if (this.value && this.value.length) {
          this.fileList = this.value
          _(this.fileList).forEach((res) => {
            if (res.url && res.url.indexOf(imgUrl) == -1) { // 域名不正确，重新拼接缩略图url
              res.url = imgUrl + res.path
            }
          })
        } else {
          this.fileList = []
        }
      },
      init() {
        if (!this.fileList) {
          this.fileList = []
        }
        this.successCb = (res, file, fileList) => {
          this.$emit('uploading', false)
          if (res.code == 200) {
            this.fileList.push({
              url: imgUrl + res.data,
              path: res.data,
              uid: file.uid,
              name: file.name
            })
            this.change()
          } else {
            _g.toastMsg(this, 'error', res.error)
          }
        }
        this.removeCb = (file, fileList) => {
          if (file) {
            this.$emit('uploading', false)
            let index = _.findIndex(this.fileList, (item) => {
              return item.uid == file.uid
            })
            this.fileList.splice(index, 1)
            this.change()
          }
        }
        this.beforeUpload = (file) => {
          if (this.config.file_type && this.config.file_type.length) {
            //  ['doc', 'docx'], ['xls', 'xlsx', 'csv']这些格式的文件，获取的file.type为''，需要在file.name中截取格式类型
            let limit = this.config.file_type
            let len = file.name.toString().split('.').length
            let type = file.name.toString().split('.')[len - 1]
            if ((!_verify.checkFileType(type, limit) && file.type == '') || (!_verify.checkFileType(file.type, limit) && file.type != '')) {
              _g.toastMsg(this, 'error', '请上传正确格式文件')
              return false
            }
          }
          if (this.config.file_max) {
            let size = this.config.file_max
            let unitCode = this.config.file_unit
            let unit = unitCode == 10 ? 'KB' : 'MB'
            if (!_verify.checkFileSize(size, unitCode, file.size)) {
              _g.toastMsg(this, 'error', `文件大小不得大于${this.config.file_max}${unit}`)
              return false
            }
          }
          return true
        }
        switch (this.config.templet) {
          case this.UPLOAD_IMAGELIST: // 照片列表
            this.listType = 'picture'
            break
          case this.UPLOAD_PHOTOWALL: // 照片墙
            this.listType = 'picture-card'
            break
          case this.UPLOAD_DRAG: // 拖拽
            this.drag = true
            break
        }
      },
      uploadProgress(eve, file, fileList) {
        this.$emit('uploading', true)
      },
      uploadError(err, res, file) {
        this.$emit('uploading', false)
        if (err) {
          console.error(err)
        }
        _g.dealError(this, res)
      },
      preview(file) {
        if (file.path) {
          window.open(imgUrl + file.path)
        } else if (file.url) {
          window.open(file.url)
        }
      },
      getFileUnit(unit) {
        if (unit == 10) {
          return 'KB'
        } else {
          return 'MB'
        }
      },
      getFileType(type) {
        if (!type || !type.length) {
          return '无'
        } else {
          let tempType = []
          _(type).forEach((item, index) => {
            _(this.fileType).forEach((cItem, cIndex) => {
              if (item == cItem.id) {
                tempType.push(cItem.name)
                return
              }
            })
          })
          return tempType.toString()
        }
      },
      change() {
        this.$emit('input', this.fileList)
      }
    },
    computed: {
      typeFileList() {
        return this.config.templet == this.UPLOAD_FILELIST
      },
      typeImageList() {
        return this.config.templet == this.UPLOAD_IMAGELIST
      },
      typePhotoWall() {
        return this.config.templet == this.UPLOAD_PHOTOWALL
      },
      typeDrag() {
        return this.config.templet == this.UPLOAD_DRAG
      }
    },
    watch: {
      'value'() {
        if (this.value != this.fileList) {
          this.initData()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// honrayUpload.vue?6333a426